module.exports = __webpack_public_path__ + "assets/img/function.4636d405.png";